$(function(){
  $('.js-accordion').find('.accordion__head').on('click', function(e){
    e.preventDefault();
    $(this).parents('.js-accordion').toggleClass('is-expanded');
    $(this).next().slideToggle();
  })
})